import { render, staticRenderFns } from "./_WithTheMenu.vue?vue&type=template&id=ff276256&scoped=true"
import script from "./_WithTheMenu.vue?vue&type=script&lang=js"
export * from "./_WithTheMenu.vue?vue&type=script&lang=js"
import style0 from "./_WithTheMenu.vue?vue&type=style&index=0&id=ff276256&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff276256",
  null
  
)

export default component.exports